// extracted by mini-css-extract-plugin
export default {"singleNft":"zUe0ZHB8pDC541s0etNi"};